<template>
  <div class="smart-apply">
    <div class="content-wrap">
      <div class="content">
        <!-- 开票类型 -->
        <div class="type-btn-wrap">
          <div
            v-for="(button, index) in invoiceType"
            :key="index"
            :class="smartApplyData.invoiceType === button.value ? 'selected-type type-btn': 'type-btn'"
            @click="changeInvoiceType(button)"
          >
            {{button.title}}
          </div>
        </div>
        <!-- 客户信息 -->
        <div class="customer-wrap">
          <SmartInputField
            type="text"
            :value="smartApplyData['purchaserName']"
            placeholder="请输入客户名称"
            @oninputchange="($event) => onInputChange({e: $event, field:'purchaserName'})"
            @onBlur="($event) => onBlur({e: $event, field:'purchaserName'})"
            @onFocus="($event) => onFocus({e: $event, field:'purchaserName'})"
          />
          <div class="customer-detail-wrap" v-if="showCustomerDetail">
            <SmartInputField
              v-for="(form, index) in customerList"
              :key="index"
              type="text"
              :value="smartApplyData[form.field]"
              :placeholder="form.placeholder"
              @oninputchange="($event) => onInputChange({e: $event, field:form.field})"
              @onBlur="($event) => onBlur({e: $event, field:form.field})"
              @onFocus="($event) => onFocus({e: $event, field:form.field})"
            />
          </div>
          <!-- 公司选择列表 -->
          <div
            class="rollup"
            v-if="showTakerList && formalinvoiceList.length > 0"
          >
            <div
              @click="onSelectCompany(item)"
              class="rollup-item"
              v-for="(item, index) in formalinvoiceList"
              :key="index"
            >
              <div class="rollup-company">
                <div>{{ item.company }}</div>
                <div v-if="item && item.managementBuyerFlag === 1">已添加</div>
              </div>
            </div>
          </div>
          <!-- 下拉按钮 -->
          <div v-if="smartApplyData.purchaserName" class="fold-wrap">
            <i
              v-if="this.showCustomerDetail"
              class="iconfont"
              @click="onChangeCustomerDetailShowed(false)"
            >&#xe6ac;</i>
            <i
              v-if="!this.showCustomerDetail"
              class="iconfont"
              @click="onChangeCustomerDetailShowed(true)"
            >&#xe636;</i>
          </div>
        </div>
        <!-- 商品列表 -->
        <div class="detail-list-wrp" v-if="goodsList.length > 0" >
          <div class="table-wrap" style="overflow: scroll">
            <table>
              <thead>
                <tr>
                  <th style="text-align: left">品名</th>
                  <th>数量</th>
                  <th style="text-align: center">单价</th>
                  <th style="text-align: center">合计</th>
                  <th style="text-align: center">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in goodsList"
                  :key="index"
                >
                  <td style="min-width: 100px;">
                    <div v-if="!item.editing">
                      {{sliceStr(item.goodsName, 7)}}
                    </div>
                    <div v-if="item.editing">
                      <SmartInputField
                        type="text"
                        :value="editingGoods.goodsName"
                        placeholder="商品名称"
                        @onFocus="($event) => onFocus({e: $event, field:'goodsName'})"
                        @oninputchange="($event)=>onInputGoods({e: $event, field: 'goodsName'})"
                      />
                    </div>
                  </td>
                  <td style="text-align: center">
                    <div v-if="!item.editing">
                      {{item.quantity}}
                    </div>
                    <div v-if="item.editing">
                      <SmartInputField
                        type="text"
                        :value="editingGoods.quantity"
                        placeholder="数量"
                        @oninputchange="($event)=>onInputGoods({e: $event, field: 'quantity'})"
                        @onFocus="($event) => onFocus({e: $event, field:'quantity'})"
                        @onBlur="($event) => onBlurGoods({e: $event, field:'quantity'})"
                      />
                    </div>
                  </td>
                  <td style="text-align: right">
                    <div v-if="!item.editing">
                      {{item.price}}
                    </div>
                    <div v-if="item.editing">
                      <SmartInputField
                        type="text"
                        :value="editingGoods.price"
                        placeholder="单价"
                        @oninputchange="($event)=>onInputGoods({e: $event, field: 'price'})"
                        @onFocus="($event) => onFocus({e: $event, field:'price'})"
                        @onBlur="($event) => onBlurGoods({e: $event, field:'price'})"
                      />
                    </div>
                  </td>
                  <td style="text-align: right">
                    <div v-if="!item.editing">
                      {{convertNumber(item.amountWithTax)}}
                    </div>
                    <div v-if="item.editing">
                      <SmartInputField
                        type="text"
                        :value="editingGoods.amountWithTax"
                        placeholder="合计"
                        @oninputchange="($event)=>onInputGoods({e: $event, field: 'amountWithTax'})"
                        @onFocus="($event) => onFocus({e: $event, field:'amountWithTax'})"
                        @onBlur="($event) => onBlurGoods({e: $event, field:'amountWithTax'})"
                      />
                    </div>
                  </td>
                  <td class="operator" style="text-align: center">
                    <i class="iconfont" v-if="!item.editing" @click="onChangeShowOperatePopup(index)">&#xe6b0;</i>
                    <i class="iconfont" v-if="item.editing" style="color: #3C54FF" @click="confirmGoods">&#xe69d;</i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="money-wrap">合计金额：{{smartApplyData.money}}</div>
          <!-- 商品选择列表 -->
          <div
            class="goodsRollup"
            v-if="searchGoodsData.length > 0"
            :style="`top: ${(100 + 56 * this.editGoodIndex + 84)/46.875}rem`"
          >
            <div
              @click="onSelectGoods(item)"
              class="rollup-item"
              v-for="(item, index) in searchGoodsData"
              :key="index"
            >
              {{ item.goodsName }}
            </div>
          </div>
        </div>
        <div class="title-wrap" @click="addGoods">
          <i class="iconfont">&#xe61f;</i>
          添加商品
        </div>
        <!-- 寄件信息 -->
        <div
          class="title-wrap"
          @click="onChangeReceiverShowed(true)"
          v-if="!showReceiver"
        >
          <i class="iconfont">&#xe61f;</i>
          添加寄件信息
        </div>
        <div class="receiver-wrap" v-if="showReceiver">
          <SmartInputField
            v-for="(form, index) in receiverList"
            :key="index"
            type="text"
            :value="smartApplyData[form.field]"
            :placeholder="form.placeholder"
            @oninputchange="($event) => onInputChange({e: $event, field: form.field})"
            @onBlur="($event) => onBlur({e: $event, field: form.field})"
            @onFocus="($event) => onFocus({e: $event, field: form.field})"
          />
        </div>
        <div class="submit-btn-wrap">
          <div class="smart-btn cancelbtn" @click="goBack">
            返回
          </div>
          <div class="smart-btn cancelbtn" @click="clear">
            清除
          </div>
          <div class="smart-btn" @click="submit">
            提交
          </div>
        </div>
      </div>
    </div>
    <!-- 操作下拉菜单 -->
    <van-popup class="operation-popup" v-model="showOperatePopup" round position="bottom" >
      <div class="popup-title">提示</div>
      <van-divider style="color: #9A9A9A; margin: 0"/>
      <div class="operation-item" @click="goodsEdit">修改</div>
      <van-divider style="color: #9A9A9A; margin: 0" />
      <div class="operation-item" @click="gotoGoodsDelete">删除</div>
      <van-divider style="color: #9A9A9A; margin: 0" />
      <div class="operation-item" @click="closeOperatePopup">取消</div>
    </van-popup>
    <!-- 确认删除modal -->
    <van-popup class="confirm-delete-popup" v-model="showConfirmPopup" round position="center" >
      <div class="confirm-tip">确定要删除该商品吗？</div>
      <div class="btn-wrap">
        <div class="smart-btn cancel-btn" @click="closeConfirmPopup">
          取消
        </div>
        <div class="smart-btn" @click="goodsDelete">
          确定
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Notify,
  Popup,
  Button,
  Cell
} from 'vant'

import {
  ConvertNumber,
  onCount,
  deepCopy,
  debounce,
  subMixStr,
  localStorage,
  getMixLength,
  isEmail,
  isSpecialTicket,
  autoMontageLookUp,
  isAllElectric,
  removeSpace
} from '@utils/basicUtil'
import {
  INVOICE_TYPE
} from '@assets/config'
import SmartInputField from '@components/SmartForm'

import { invoiceRequest, customerRequest } from '@services'

export default {
  data: () => ({
    showTakerList: false,
    showCustomerDetail: false,
    showReceiver: false,
    formalinvoiceListLoading: false,
    showOperatePopup: false,
    showConfirmPopup: false,
    invoiceType: INVOICE_TYPE,
    customerList: [
      {
        type: 'text',
        field: 'purchaserTaxNo',
        placeholder: '请输入客户税号'
      },
      {
        type: 'text',
        field: 'purchaserAddress',
        placeholder: '请输入地址、电话'
      },
      {
        type: 'text',
        field: 'purchaserBankName',
        placeholder: '请输入银行、账号'
      }
    ],
    goodsFormList: [
      {
        type: 'text',
        field: 'goodsName',
        placeholder: '商品名称'
      },
      {
        type: 'text',
        field: 'quantity',
        placeholder: '数量'
      },
      {
        type: 'text',
        field: 'price',
        placeholder: '单价'
      },
      {
        type: 'text',
        field: 'amountWithTax',
        placeholder: '合计'
      }
    ],
    receiverList: [
      {
        type: 'text',
        field: 'receiverName',
        placeholder: '请输入收件人'
      },
      {
        type: 'text',
        field: 'receiverAddress',
        placeholder: '请输入收件地址'
      },
      {
        type: 'text',
        field: 'receiverPhone',
        placeholder: '请输入电话'
      }
    ],
    formalinvoiceList: [],
    goodsData: [],
    searchGoodsData: [],
    editGoodIndex: 0,
    editingGoods: {},
    screenHeight: null
  }),
  computed: {
    merchantId () {
      return this.$store.state.invoice.smartMerchantId
    },
    smartApplyData () {
      return this.$store.state.invoice.smartApplyData
    },
    goodsList () {
      return this.$store.state.invoice.smartGoodsList
    },
    invoiceTypeLimit () {
      return this.$store.state.invoice.smartInvoiceLimits
    },
    sum () {
      // calc money
      let sum = 0
      this.$store.state.invoice.smartGoodsList.forEach((goods) => {
        sum = onCount.add(sum, goods.amountWithTax)
      })

      return sum.toFixed(2)
    }
  },
  watch: {
    invoiceTypeLimit (newValue) {
      this.invoiceTypeOptions()
    }
  },
  mounted () {
    this.invoiceTypeOptions()
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    clear () {
      this.$store.commit('invoice/initSmartApplyData')
      this.$store.commit('invoice/initSmartMerchantInfo')
      this.invoiceTypeOptions()
      this.$store.commit('invoice/changeSmartGoodsList', [])
    },
    getScreenHeight () {
      if (!this.screenHeight) {
        let screenHeight
        if (window.innerHeight) {
          screenHeight = window.innerHeight
        } else if ((document.body) && (document.body.clientHeight)) {
          screenHeight = document.body.clientHeight
        }
        this.screenHeight = screenHeight
        window.$('html,body').height(screenHeight)
      } else {
        window.$('html,body').height(this.screenHeight)
      }
    },
    closeConfirmPopup () {
      this.showConfirmPopup = false
      this.closeOperatePopup()
    },
    closeOperatePopup () {
      this.showOperatePopup = false
    },
    goodsEdit () {
      const res = {
        ...deepCopy(this.goodsList[this.editGoodIndex]),
        editing: true
      }
      this.editingGoods = res
      this.goodsList.splice(this.editGoodIndex, 1, res)
      this.changeGoodsList(this.goodsList)
      this.showOperatePopup = false
    },
    gotoGoodsDelete () {
      this.showConfirmPopup = true
    },
    goodsDelete () {
      this.goodsList.splice(this.editGoodIndex, 1)
      this.changeGoodsList(this.goodsList)
      this.changeApply({
        money: this.sum
      })
      this.closeConfirmPopup()
    },
    onChangeShowOperatePopup (index) {
      this.editGoodIndex = index
      this.showOperatePopup = true
    },
    confirmGoods () {
      let editData = deepCopy(this.editingGoods)
      // validation
      if (!this.editingGoods.goodsName && (!editData.amountWithTax || !Number(editData.amountWithTax))) {
        this.editingGoods = null
        this.goodsDelete()
        return
      }
      if (editData.amountWithTax && !Number(editData.amountWithTax)) {
        return Notify({ type: 'danger', message: '请输入商品数量和单价' })
      }
      const sameGoodsList = this.goodsList.filter(v => v.goodsName === editData.goodsName && v.specification === editData.specification)
      if (this.editType === 'add') {
        if (sameGoodsList.length) {
          return Notify({ type: 'danger', message: '已存在相同商品，请修改商品的规格型号后再添加' })
        }
      } else {
        if (sameGoodsList.length > 1) {
          return Notify({ type: 'danger', message: '已存在相同商品，请修改商品的规格型号后再添加' })
        }
      }

      if (!editData.quantity && !editData.price) {
        this.editingGoods.price = null
        this.editingGoods.quantity = null
      } else {
        const tempAmountWithTax = this.calcAmountWithTax(editData)
        if (editData.amountWithTax !== tempAmountWithTax) {
          this.editingGoods.amountWithTax = tempAmountWithTax
        }
      }

      this.editingGoods.editing = false
      this.goodsList.splice(this.editGoodIndex, 1, deepCopy(this.editingGoods))
      this.changeGoodsList(this.goodsList)
      this.changeApply({
        money: this.sum
      })
      this.closeGoodsSeletion()
    },
    async getGoodsList (id) {
      const data = await invoiceRequest.goods.getGoodsList({
        current: 1,
        size: 999,
        status: 0
      })

      if (data.success) {
        const arr = deepCopy(data.result.records)
        const resArr = arr.map((v, i) => {
          const originPrice = v.price
          let resPrice
          if (v.taxPre === 1 && v.taxSign === 0) {
            // 不免税 && 免税价格 => 需要加税显示含税价格
            resPrice = onCount.mul(originPrice, onCount.add(1, v.taxRate))
          }
          const res = {
            ...v,
            quantity: 1,
            price: this.convertPrice(resPrice || originPrice),
            taxSign: 1
          }
          res.amountWithTax = this.calcAmountWithTax(res)
          return res
        })
        this.goodsData = resArr
      } else {
        this.goodsData = []
        Notify({ type: 'danger', message: data.message })
      }
    },
    calcAmountWithTax (goods) {
      const {
        taxPre,
        taxSign,
        taxRate = 0,
        price,
        quantity = 1
      } = goods
      const calcTaxRate = onCount.add(1, taxRate)
      const tempAmountWithTax = onCount.mul(price, quantity)
      let amountWithTax
      if (taxPre === 1 && this.showTaxSign) {
        // 不免税且显示是否含税标示
        amountWithTax = onCount.mul(tempAmountWithTax, (taxSign ? 1 : calcTaxRate))
      }
      return (amountWithTax || tempAmountWithTax).toFixed(2)
    },
    addGoods () {
      this.showTakerList = false
      const editingGoods = this.goodsList.filter(goods => goods.editing)
      if (editingGoods.length) {
        this.confirmGoods()
        return this.addGoods()
      }
      this.editingGoods = {
        goodsName: '',
        quantity: '',
        price: '',
        amountWithTax: 0,
        taxSign: 1,
        editing: true,
        taxPre: 1
      }
      this.goodsList.push(this.editingGoods)
      this.editGoodIndex = this.goodsList.length - 1
      if (!this.goodsData.length) {
        this.getGoodsList()
      }
    },
    closeGoodsSeletion () {
      this.searchGoodsData = []
    },
    onSelectGoods (goods) {
      this.editingGoods = {
        ...goods,
        editing: true
      }
      this.closeGoodsSeletion()
    },
    changeInvoiceType (button) {
      this.changeApply({
        invoiceType: button.value
      })
      if (button.value === '3' || button.value === '4') {
        // 电票填写receiverEmail
        this.receiverList[1] = {
          type: 'text',
          field: 'receiverEmail',
          placeholder: '请输入收件邮箱'
        }
      } else {
        // 非电票填写receiverAddress
        this.receiverList[1] = {
          type: 'text',
          field: 'receiverAddress',
          placeholder: '请输入收件地址'
        }
      }
    },
    sliceStr (text, len) {
      if (text && text.length > len) {
        return text.slice(0, len) + '...'
      } else {
        return text
      }
    },
    convertPrice (price) {
      const priceStr = String(price)
      if (priceStr.length > 15) {
        return priceStr.substr(0, 15)
      }
      return price
    },
    invoiceTypeOptions () {
      const invoiceLimit = localStorage.get('invoiceLimits')
      if (!invoiceLimit) {
        this.$router.push('/')
      }
      const options = deepCopy(INVOICE_TYPE)
      const resInvoiceLimit = invoiceLimit.split(',')
      const resInvoiceType = []
      resInvoiceLimit.forEach(j => {
        options.forEach(item => {
          if (j === item.value) {
            resInvoiceType.push(item)
          }
        })
      })
      this.changeInvoiceType(resInvoiceType[0])
      this.invoiceType = resInvoiceType
    },
    changeApply (params) {
      this.$store.commit('invoice/changeSmartApplyData', {
        data: params
      })
    },
    changeGoodsList (goodsList) {
      this.$store.commit('invoice/changeSmartGoodsList', goodsList)
    },
    submit () {
      // validation
      const {
        invoiceType,
        purchaserName,
        purchaserTaxNo,
        purchaserAddress,
        purchaserBankName,
        receiverName,
        receiverAddress,
        receiverPhone,
        receiverEmail,
        logisticsFlag
      } = this.smartApplyData

      if (!purchaserName || !purchaserName.trim().length) {
        return Notify({ type: 'danger', message: '客户名称不能为空' })
      } else if (
        purchaserName.length >= 50
      ) {
        return Notify({ type: 'danger', message: '客户名称不能超过50个字符' })
      }
      if (isSpecialTicket(invoiceType)) {
        if (purchaserTaxNo.trim().length === 0) {
          return Notify({ type: 'danger', message: '请输入客户税号!' })
        } else if (purchaserTaxNo.trim().length !== 0 &&
          !/^[0-9A-Za-z]{9}$/.test(purchaserTaxNo) &&
          !/^[0-9A-Za-z]{15}$/.test(purchaserTaxNo) &&
          !/^[0-9A-Za-z]{17}$/.test(purchaserTaxNo) &&
          !/^[0-9A-Za-z]{18}$/.test(purchaserTaxNo) &&
          !/^[0-9A-Za-z]{19}$/.test(purchaserTaxNo) &&
          !/^[0-9A-Za-z]{20}$/.test(purchaserTaxNo)
        ) {
          return Notify({ type: 'danger', message: '客户税号输入有误' })
        }
        if (!isAllElectric(invoiceType)) {
          if (!purchaserAddress || !purchaserBankName) {
            return Notify({ type: 'danger', message: '公司信息必填' })
          }
        }
      } else {
        if (purchaserTaxNo && (!/^[a-zA-Z0-9]+$/.test(purchaserTaxNo.trim()) || purchaserTaxNo.trim().length > 20)) {
          return Notify({ type: 'danger', message: '税号格式错误仅支持数字/字母，长度小于/等于20位' })
        }
      }
      if (invoiceType !== '7' && invoiceType !== '8') {
        if (purchaserAddress && getMixLength(purchaserAddress) > 100) {
          return Notify({ type: 'danger', message: '购方地址电话不能超过50个汉字' })
        }
        if (purchaserBankName && getMixLength(purchaserBankName) > 100) {
          return Notify({ type: 'danger', message: '购方银行账号不能超过50个汉字' })
        }
      }
      // 商品
      if (!this.goodsList || !this.goodsList.length) {
        return Notify({ type: 'danger', message: '请选择开票商品' })
      }
      const wrongPrice = this.goodsList.filter((goods) => !goods.amountWithTax || goods.amountWithTax === '0' || goods.amountWithTax === '0.00')
      if (wrongPrice.length) {
        return Notify({ type: 'danger', message: '商品价格需大于0' })
      }
      if (logisticsFlag === '1') {
        if (!receiverName) {
          return Notify({ type: 'danger', message: '请填写收件人' })
        }
      }

      if (invoiceType === '3' || invoiceType === '4') {
        // 电票，收件人和邮箱必填
        if (!receiverName) {
          return Notify({ type: 'danger', message: '请填写收件人' })
        }
        if (!receiverEmail) {
          return Notify({ type: 'danger', message: '请填写收件邮箱' })
        } else if (!isEmail(receiverEmail)) {
          return Notify({ type: 'danger', message: '邮箱格式不正确' })
        }
      } else {
        // 专票和普票邮件信息可以为空，其他信息必填
        if (logisticsFlag === '1') {
          if (!receiverAddress) {
            return Notify({ type: 'danger', message: '请填写收件地址' })
          }
          if (!receiverPhone) {
            return Notify({ type: 'danger', message: '请填写收件电话' })
          }
        }
      }

      if (logisticsFlag === '1') {
        if (receiverEmail && !isEmail(receiverEmail)) {
          return Notify({ type: 'danger', message: '邮箱格式不正确' })
        }
      }
      // 发起申请
      this.saveApply()
    },
    onChangeCustomerDetailShowed (bool) {
      this.showCustomerDetail = bool
    },
    onChangeReceiverShowed (bool) {
      this.testEditingGoods()
      this.showReceiver = bool
    },
    onSelectCompany (item) {
      const { address, bankName, company, taxNo, id } = autoMontageLookUp(item, this.smartApplyData.invoiceType)
      this.changeApply({
        purchaserName: company,
        purchaserTaxNo: taxNo,
        purchaserAddress: `${address}`,
        purchaserBankName: `${bankName}`
      })
      this.showCustomerDetail = true
      if (id) {
        this.$store.commit('invoice/changeSmartMerchantId', id)
        this.getReceiver(id)
      }
      this.$store.commit('invoice/changeSmartMerchantInfo', { ...item })
      this.formalinvoiceList = []
    },
    onBlurGoods ({ e, field }) {
      if (field === 'price') {
        this.testPrice(e)
      }
      if (field === 'quantity') {
        this.testQuantity(e)
      }
      if (field === 'amountWithTax') {
        this.testAmount(e)
      }
    },
    onInputGoods ({ e, field }) {
      this.editingGoods[field] = e
      if (field === 'goodsName') {
        this.onSearchGoods(e)
      }
      if (field === 'price' || field === 'quantity') {
        this.mulSum()
      }
    },
    mulSum () {
      const goods = deepCopy(this.editingGoods)
      const {
        price,
        quantity = 1
      } = goods
      const tempAmountWithTax = onCount.mul(Number(price), Number(quantity))
      this.editingGoods.amountWithTax = tempAmountWithTax.toFixed(2)
    },
    onInputChange ({ e, field }) {
      if (field === 'purchaserName') {
        this.showTakerList = true
        this.onSearch(e)
      }
      this.changeApply({
        [field]: removeSpace(e)
      })
    },
    onBlur ({ e, field }) {
      if (field === 'purchaserName') {
        this.testBuyerName(e)
      }
    },
    testAmount () {
      if (!this.editingGoods.amountWithTax || !Number(this.editingGoods.amountWithTax)) {
        return Notify({ type: 'danger', message: '请输入正确的合计价格' })
      }
      try {
        this.editingGoods.price = this.calcPriceOrQtyWithAmount(this.editingGoods)
      } catch (e) {
        return Notify({ type: 'danger', message: '请输入商品数量和单价' })
      }
    },
    testQuantity () {
      this.resetScrollTop()
      const goods = this.editingGoods
      if (Number(goods.quantity) < 0) {
        goods.quantity = Math.abs(Number(goods.quantity)).toString()
      }
    },
    testPrice () {
      this.resetScrollTop()
      const goods = this.editingGoods
      if (!/^\d+$|^\d*\.\d+$/g.test(goods.price)) {
        if (Number(goods.price) < 0) {
          goods.price = Math.abs(Number(goods.price)).toString()
        } else {
          goods.price = ''
        }
      }
    },
    resetScrollTop () {
      setTimeout(() => {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 100)
    },
    testBuyerName () {
      if (!this.smartApplyData.purchaserName.length) {
        return Notify({ type: 'danger', message: '请填写发票抬头' })
      } else {
        this.smartApplyData.purchaserName = subMixStr(this.smartApplyData.purchaserName, 100)
      }
    },
    onFocus ({ e, field }) {
      this.getScreenHeight()
      if (field === 'purchaserName') {
        this.showTakerList = true
      } else {
        this.showTakerList = false
      }

      if (field !== 'goodsName') {
        this.closeGoodsSeletion()
      }

      if (
        field !== 'goodsName' &&
        field !== 'price' &&
        field !== 'quantity' &&
        field !== 'amountWithTax'
      ) {
        this.testEditingGoods()
      }
    },
    testEditingGoods () {
      const editingGoods = this.goodsList.filter(goods => goods.editing)
      if (editingGoods.length) {
        this.confirmGoods()
      }
    },
    debounce: debounce((vm) => { vm.getCustomerListByName() }, 300),
    debounceGoods: debounce((vm) => { vm.getGoodsListByName() }, 300),
    onSearch (value) {
      if (value.length >= 1) {
        this.debounce(this)
      }
    },
    onSearchGoods (name) {
      this.goodsName = name
      this.debounceGoods(this)
    },
    convertNumber (data) {
      return ConvertNumber(data)
    },
    calcPriceOrQtyWithAmount (goods) {
      const {
        quantity,
        amountWithTax
      } = goods

      if (quantity) {
        const resPrice = onCount.div(amountWithTax, quantity)
        return resPrice
      }
    },
    getGoodsListByName () {
      if (!this.goodsName) {
        return
      }
      const data = this.goodsData.filter(goods => goods.goodsName.indexOf(this.goodsName) >= 0)
      this.searchGoodsData = data
      // if (!data.length) {
      //   Notify({ type: 'danger', message: '商品未在系统查询到。需要手工输入' })
      // }
    },
    handleApplyData () {
      const postData = {
        ...this.smartApplyData,
        invoiceType: Number(this.smartApplyData.invoiceType),
        logisticsFlag: Number(this.smartApplyData.logisticsFlag),
        details: this.goodsList.map(goods => {
          return {
            amountWithTax: goods.amountWithTax,
            goodsName: goods.goodsName,
            quantity: goods.quantity,
            specification: goods.specification,
            taxSign: goods.taxSign,
            unit: goods.unit,
            unitPrice: goods.price,
            shortName: goods.shortName,
            zeroTax: goods.zeroTax,
            taxPre: goods.taxPre,
            taxPreType: goods.taxPreType,
            splitCode: goods.splitCode,
            goodsTypeCode: goods.goodsTypeCode,
            revenueCode: goods.revenueCode,
            immediateLevyRefundCode: goods.immediateLevyRefundCode,
            revenueVersion: goods.revenueVersion,
            taxRate: goods.taxRate
          }
        })
      }
      return postData
    },

    addOrEditAddress () {
      return new Promise(async (resolve, reject) => {
        const merchantInfo = this.$store.state.invoice.smartMerchantInfo
        const postData = {}

        const delEmptyParam = (data) => {
          for (let ele in data) {
            !data[ele] && typeof data[ele] !== 'number' && delete data[ele]
          }
          for (let key in data) {
            typeof data[key] === 'string' && !data[key].length && delete data[key]
          }
        }

        if (Number(this.smartApplyData.logisticsFlag) === 1) {
          let addressData = {
            address: this.smartApplyData.receiverAddress,
            userName: this.smartApplyData.receiverName,
            telephone: this.smartApplyData.receiverPhone,
            email: this.smartApplyData.receiverEmail,
            defaultFlag: 1,
            merchantId: (merchantInfo.id && merchantInfo.id.length) ? merchantInfo.id : ''
          }
          delEmptyParam(addressData)
          postData.addresseeInfoRequestList = [{
            ...addressData
          }]
        }

        postData.merchantArchivesVo = {
          id: merchantInfo.id,
          company: this.smartApplyData.purchaserName,
          nature: merchantInfo.nature,
          taxNo: this.smartApplyData.purchaserTaxNo,
          address: this.smartApplyData.purchaserAddress,
          bankName: this.smartApplyData.purchaserBankName,
          receiverEmail: this.smartApplyData.receiverEmail,
          enable: 0
        }

        delEmptyParam(postData.merchantArchivesVo)

        await customerRequest.address.addOrEdit({
          ...postData
        })

        resolve(true)
      })
    },
    async getCustomerListByName () {
      this.$store.commit('invoice/initSmartMerchantInfo')
      if (!this.smartApplyData.purchaserName) {
        return
      }
      const data = await invoiceRequest.customer.getCustomersByName({ companyName: this.smartApplyData.purchaserName })
      if (data.success) {
        if (data.result.length) {
          this.formalinvoiceList = data.result
        } else {
          this.formalinvoiceList = []
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async getReceiver (merchantId) {
      const data = await invoiceRequest.customer.getDefaultReceiver({ merchantId })
      if (data.success) {
        const {
          userName,
          address,
          telephone,
          email
        } = data.result
        this.changeApply({
          receiverName: userName,
          receiverAddress: address,
          receiverPhone: telephone,
          receiverEmail: email
        })
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async getDefaultTaker () {
      const data = await invoiceRequest.taker.getDefaultTaker({})
      if (data.success) {
        if (data.result) {
          const {
            taker,
            takerIdCard,
            takerTelephone
          } = data.result
          this.changeApply({
            taker,
            takerIdCard,
            takerTelephone
          })
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async saveApply () {
      this.$toast.loading()
      const postData = this.handleApplyData()
      const data = await invoiceRequest.apply.save({ ...postData, settlementSource: 12 })
      if (data.success) {
        this.$store.commit('user/changeRefreshStatistics', true)
        await this.addOrEditAddress()
        Notify({ type: 'success', message: '申请提交成功' })
        this.$router.push('/')
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    }
  },
  components: {
    SmartInputField,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Cell.name]: Cell
  }
}

</script>

<style lang="less" scoped src="./style.less"/>
